var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: { width: "500px", height: "auto", top: "10vh", title: "" },
      on: {
        success: function ($event) {
          return _vm.sure()
        },
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c("div", { staticClass: "detectionVideo_content" }, [
        _c("div", { staticClass: "item1" }, [
          _vm._v(" 系统检测到您有 "),
          _c(
            "span",
            { staticStyle: { color: "#f53f3f", "font-size": "24px" } },
            [_vm._v(_vm._s(_vm.nums))]
          ),
          _vm._v(" 个账号数据未同步 "),
        ]),
        _c(
          "div",
          { staticClass: "item1", staticStyle: { "margin-top": "15px" } },
          [_vm._v(' 需要点击"数据一键同步"完成数据同步后才能继续使用该功能 ')]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "footer_btn",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.btnText))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.sure()
                },
              },
            },
            [_vm._v("立即去同步")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }